import { IonContent, IonHeader, IonPage, IonRouterLink } from '@ionic/react';
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { PageLinks } from '../common/Constants';

import { Helmet } from 'react-helmet';

const ShippingPolicy: React.FC = () => {

    return (
        <>
            <Helmet>‍
                <title>Customized Ready to install Mosquito nets with frames | Shipping Policy</title>
                <meta name='title' content='Customized Ready to install Mosquito nets with frames' />
                <meta property='og:url' content='https://www.venetz.in/shipping-policy' />
                <meta property='og:type' content='website' />
                <meta property='og:title' content='VENETZ | Shipping Policy' />
                <meta property='og:description' content='VENETZ | Shipping Policy' />
                <meta property='og:site_name' content='VENETZ' />
            </Helmet>
            <IonPage>
                {/* <Menu /> */}
                <IonHeader>
                    <Header />
                </IonHeader>
                <IonContent fullscreen id="main-content">
                    {/* <section className="page-banner">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span className="round-shape"></span>
                                    <h2 className="banner-title">Shipping & Return Policy</h2>
                                    <div className="bread-crumb"><IonRouterLink routerLink={PageLinks.HOME} className='bread-crumb-text'>Home</IonRouterLink> / Shipping & Return Policy</div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="popular-section white_bg">
                        <div className="shape-round">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="testimonials-content">
                                        <p className='privacy_com_content'>
                                            LEGAL NAME : VIMAL NETS   <br />
                                            TRADE NAME : VENETZ
                                            <br /><br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2 className="sec-title">SHIPPING & RETURN POLICY</h2>
                                    <div className="testimonials-content">
                                        <p className='about_content'>No returns are allowed. Only a replacement for manufacturing defects is available. Kindly verify before you order to ensure a smooth experience.</p>
                                        <p className='about_content'>In the unlikely event that any merchandise you have ordered from us is not received in good condition, is damaged or defective, or if merchandise delivered is different from what you had expected, you may return the merchandise unused, in its original packaging and tags.</p>
                                        <p className='about_content'>Any exchange or returns for reasons other than the above, the shipping charges if any, will not be refunded.</p>
                                        <p className='about_content'>Before accepting delivery of any merchandise, please ensure, that the packaging has not been damaged or tampered with. If you believe that the merchandise is not in good condition, or if the packaging is tampered with or damaged, before accepting delivery of the goods, please refuse to take delivery of the package, and write to us at info@venetz.in, mentioning your order reference number. We shall make our best efforts to ensure that a replacement delivery is made to you at the earliest.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 mt-20">
                                    <h2 className="sec-title">THE EXTERNAL PACKAGING WAS DAMAGED</h2>
                                    <div className="testimonials-content">
                                        <p className='about_content'>At the time of delivery if you notice that the external packing of the consignment is damaged or tampered with, please do not accept the package. Instead, add your remarks on the courier delivery sheet and raise a complaint with us immediately, citing your order details. We will resolve your issue with the respective courier partner.</p>
                                        <p className='about_content'>Once our courier partner updates that your parcel is accepted for return and updates this on their website, we will start your refund process..</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> */}
                    <section className="page-banner">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span className="round-shape"></span>
                                    <h2 className="banner-title">Shipping & Return Policy</h2>
                                    <div className="bread-crumb"><IonRouterLink routerLink={PageLinks.HOME} className='bread-crumb-text'>Home</IonRouterLink> / Shipping & Return Policy</div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* <section className="popular-section white_bg py-5">
                        <div className="container position-relative">
                            <div className="shape-round position-absolute top-0 start-0 w-100 h-100">
                                <span></span><span></span><span></span><span></span><span></span>
                            </div>

                            <div className="row justify-content-center mb-4">
                                <div className="col-lg-10 text-start">
                                    <div className="testimonials-content">
                                        <p className='privacy_com_content mb-0'>
                                            <strong>LEGAL NAME:</strong> VIMAL NETS<br />
                                            <strong>TRADE NAME:</strong> VENETZ
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center mb-4">
                                <div className="col-lg-10">
                                    <h2 className="sec-title mb-3">SHIPPING & RETURN POLICY</h2>
                                    <div className="testimonials-content">
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-success" style={{ fontSize: '20px' }}>• </span>
                                            <span>No returns are allowed. Only a replacement for manufacturing defects is available. Kindly verify before you order to ensure a smooth experience.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-success" style={{ fontSize: '20px' }}>• </span>
                                            <span>In the unlikely event that any merchandise you have ordered from us is not received in good condition, is damaged or defective, or if merchandise delivered is different from what you had expected, you may return the merchandise unused, in its original packaging and tags.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-success" style={{ fontSize: '20px' }}>• </span>
                                            <span>Any exchange or returns for reasons other than the above, the shipping charges if any, will not be refunded.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-success" style={{ fontSize: '20px' }}>• </span>
                                            <span>Before accepting delivery of any merchandise, please ensure that the packaging has not been damaged or tampered with. If so, refuse delivery and contact us at <a href="mailto:info@venetz.in" className="text-decoration-none text-primary">info@venetz.in</a> with your order reference number.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <h2 className="sec-title mb-3">THE EXTERNAL PACKAGING WAS DAMAGED</h2>
                                    <div className="testimonials-content">
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-info" style={{ fontSize: '20px' }}>•</span>
                                            <span>If the external packaging is damaged or tampered with during delivery, please do not accept the package. Add remarks on the delivery sheet and inform us immediately with your order details.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-info" style={{ fontSize: '20px' }}>•</span>
                                            <span>Once our courier partner confirms the return in their system, we will begin your refund process.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> */}

                    <section className="popular-section white_bg py-5">
                        <div className="container position-relative">
                            <div className="shape-round position-absolute top-0 start-0 w-100 h-100">
                                <span></span><span></span><span></span><span></span><span></span>
                            </div>

                            <div className="row justify-content-center mb-4">
                                <div className="col-lg-10 text-start">
                                    <div className="testimonials-content">
                                        <p className='privacy_com_content mb-0'>
                                            <strong>LEGAL NAME:</strong> VIMAL NETS<br />
                                            <strong>TRADE NAME:</strong> VENETZ
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center mb-4">
                                <div className="col-lg-10">
                                    <h2 className="sec-title mb-3">SHIPPING & RETURN POLICY</h2>
                                    <div className="testimonials-content">
                                        <p>At VENETZ, we are committed to providing high-quality mosquito nets that meet the comfort and safety needs of every home. To maintain fairness and transparency for all our customers, we request you to carefully read our shipping and return policy before placing your order.</p>

                                        <h5 className="mt-4 mb-2">Shipping Policy:</h5>
                                        <div className="about_content mb-2 d-flex">
                                            <span className="mx-2 text-primary" style={{ fontSize: '20px' }}>•</span>
                                            <span>All standard and custom orders are shipped within the timeline informed during the purchase.</span>
                                        </div>
                                        <div className="about_content mb-2 d-flex">
                                            <span className="mx-2 text-primary" style={{ fontSize: '20px' }}>•</span>
                                            <span>Tracking details will be shared once the shipment is dispatched.</span>
                                        </div>
                                        <div className="about_content mb-4 d-flex">
                                            <span className="mx-2 text-primary" style={{ fontSize: '20px' }}>•</span>
                                            <span>In case of any delay, our support team will keep you informed proactively.</span>
                                        </div>

                                        <h5 className="mb-3">Return & Replacement Policy:</h5>

                                        <p className="text-danger fw-bold mb-2">🔴 No Return Policy</p>
                                        <p className="mb-3">We do not accept returns under any circumstances unless there is a genuine manufacturing defect in the product.</p>

                                        <p className="text-success fw-bold mb-2">🛠 Replacement for Manufacturing Defects Only</p>
                                        <p className="mb-3">If you receive a product with a verifiable manufacturing defect, we will gladly offer a free replacement. Please inform us within 48 hours of delivery with clear pictures and order details.</p>

                                        <p className="text-primary fw-bold mb-2">📏 Size Confirmation is Mandatory</p>
                                        <div className="about_content mb-2 d-flex">
                                            <span className="mx-2 text-info" style={{ fontSize: '20px' }}>•</span>
                                            <span><strong>Standard Sizes:</strong> All our VENETZ products are made as per our clearly mentioned standard dimensions. Kindly verify if your cot/bed fits within our standard size chart before placing the order.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-info" style={{ fontSize: '20px' }}>•</span>
                                            <span><strong>Custom Sizes:</strong> For custom orders, there is no return or replacement available unless a manufacturing defect is proven. Please ensure that all measurements and requirements are clearly confirmed before production begins.</span>
                                        </div>

                                        <p className="text-muted fw-bold mb-2">💬 Clarify Before You Buy</p>
                                        <p>Please take the time to confirm all parameters to avoid inconvenience. Our team is available to assist you with any doubts or queries before your purchase.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <h2 className="sec-title mb-3">THE EXTERNAL PACKAGING WAS DAMAGED</h2>
                                    <div className="testimonials-content">
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-danger" style={{ fontSize: '20px' }}>•</span>
                                            <span>If the external packaging is damaged or tampered with during delivery, please do not accept the package. Add remarks on the delivery sheet and inform us immediately with your order details.</span>
                                        </div>
                                        <div className="about_content mb-3 d-flex">
                                            <span className="mx-2 text-danger" style={{ fontSize: '20px' }}>•</span>
                                            <span>Once our courier partner confirms the return in their system, we will begin your refund process.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <Footer />
                </IonContent>
            </IonPage>
        </>
    );
};
export default ShippingPolicy;
